import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import * as MaterialUI from 'material-ui';
import FontAwesome from 'react-fontawesome';
import { Row, Col, Container } from 'reactstrap';
import InfiniteScroll from 'react-infinite-scroller';
import areIntlLocalesSupported from 'intl-locales-supported';
import { push } from 'react-router-redux';

import * as generalActions from 'modules/general/action';
import * as gruposActions from 'modules/grupos/action';
import * as gruposSolicitudesAction from '../action';

import { checkPermissions, listFindByMapId } from 'core/generalFunctions';

@connect(store => ({
  gruposSolicitudes: store.getIn(['gruposSolicitudes', 'lista']),
  listaSeleccionados: store.getIn(['gruposSolicitudes', 'listaSeleccionados']),
  gruposList: store.getIn(['grupos', 'lista']),
  viajesList: store.getIn(['']),
  scrollControl: store.getIn(['gruposSolicitudes', 'scrollControl']),
  loading: store.getIn(['general', 'loadingbar', 'show']),
}))
export default class extends React.Component {
  componentDidMount = () => {
    this.props.dispatch(generalActions.dashboard_changeTitle('SOLICITUDES'));
    this.props.gruposSolicitudes.size === 0 && this.filtrar();
  };
  filtrar = () => {
    const { scrollControl } = this.props;
    this.props.dispatch(gruposSolicitudesAction.getGruposSolicitudes(scrollControl.get('page') * 100));
  };
  componentWillUnmount = () => {
    this.props.dispatch(gruposSolicitudesAction.clear('lista'));
    this.props.dispatch(gruposActions.clear('lista'));
  };
  seleccionar = (solicitudId, seleccionada) => this.props.dispatch(gruposSolicitudesAction.seleccionar(solicitudId, seleccionada));
  seleccionarTodas = seleccionar => this.props.dispatch(gruposSolicitudesAction.seleccionarTodas(seleccionar));
  aceptarSeleccionadas = aceptar => {
    const { listaSeleccionados } = this.props;
    let solicitudesId = listaSeleccionados.toJS();
    this.props.dispatch(gruposSolicitudesAction.aceptarSolicitudes(solicitudesId, aceptar));
  };
  openPadreSolicitud = (grupoId, viajeId) => {
    if (grupoId) this.props.dispatch(push('/dashboard/grupos/add/' + grupoId));
    else if (viajeId) this.props.dispatch(push('/dashboard/reservas/pasajeros/' + viajeId));
  };
  render() {
    const { gruposSolicitudes, loading, scrollControl, listaSeleccionados } = this.props;
    return (
      <Container fluid>
        <Row>
          <Col md="12">
            <MaterialUI.Paper zDepth={2}>
              <Row className="p-lr-10">
                <Col md="3" className="pt-25 ml-30">
                  <MaterialUI.RaisedButton
                    primary
                    label={listaSeleccionados.size == gruposSolicitudes.size ? 'Deseleccionar todas' : 'Seleccionar todas'}
                    className="mb-20"
                    disabled={loading || gruposSolicitudes.size === 0}
                    onTouchTap={() => this.seleccionarTodas(listaSeleccionados.size !== gruposSolicitudes.size)}
                  />
                </Col>
                <Col md={{ size: 3, offset: 2 }} className="pt-25">
                  <MaterialUI.RaisedButton
                    primary
                    label={'Aceptar seleccionadas (' + listaSeleccionados.size + ')'}
                    className="mb-20"
                    disabled={loading || listaSeleccionados.size === 0}
                    onTouchTap={() => this.aceptarSeleccionadas(true)}
                  />
                </Col>
                <Col md={{ size: 3 }} className="pt-25">
                  <MaterialUI.RaisedButton
                    label={'Denegar seleccionadas (' + listaSeleccionados.size + ')'}
                    className="mb-20"
                    disabled={loading || listaSeleccionados.size === 0}
                    onTouchTap={() => this.aceptarSeleccionadas(false)}
                  />
                </Col>
              </Row>
            </MaterialUI.Paper>
          </Col>
          <Col md="12">
            <InfiniteScroll
              pageStart={0}
              threshold={1}
              className="container"
              initialLoad={false}
              loadMore={scrollControl.get('hasMore') ? this.filtrar : () => false}
              hasMore={!loading && scrollControl.get('hasMore')}
            >
              <GenerateList gruposSolicitudes={gruposSolicitudes} openPadreSolicitud={this.openPadreSolicitud} listaSeleccionados={listaSeleccionados} seleccionar={this.seleccionar} />
            </InfiniteScroll>
          </Col>
        </Row>
      </Container>
    );
  }
}

const GenerateList = props => {
  const { gruposSolicitudes, listaSeleccionados, seleccionar, openPadreSolicitud } = props;
  if (!gruposSolicitudes || gruposSolicitudes.size == 0) return <h1 className="textCenter pt-20">No hay solicitudes nuevas</h1>;
  const returnElements = [];
  const elementsPerIDSolicitud = {};
  try {
    gruposSolicitudes.map(solicitud => {
      const IDSolicitud = solicitud.get('grupoId') || solicitud.get('viajeId');
      if (!elementsPerIDSolicitud[IDSolicitud]) {
        elementsPerIDSolicitud[IDSolicitud] = [
          <MaterialUI.ListItem
            key={IDSolicitud}
            primaryText={(solicitud.get('grupoId') && solicitud.getIn(['_grupo', 'nombre'])) || (solicitud.get('viajeId') && solicitud.getIn(['_viaje', 'nombre']))}
            onClick={() => openPadreSolicitud(solicitud.get('grupoId'), solicitud.get('viajeId'))}
          />,
        ];
      }
      elementsPerIDSolicitud[IDSolicitud].push(
        <MaterialUI.ListItem
          key={solicitud.get('id')}
          leftCheckbox={
            <MaterialUI.Checkbox checked={listaSeleccionados.findIndex(i => i === solicitud.get('id')) !== -1} onCheck={(event, isInputChecked) => seleccionar(solicitud.get('id'), isInputChecked)} />
          }
          primaryText={solicitud.getIn(['_usuario', 'nombre']) + ' ' + solicitud.getIn(['_usuario', 'apellido']) + ' ' + solicitud.getIn(['_usuario', 'documento'])}
          secondaryText={'Solicitud enviada: ' + moment(solicitud.get('fechaCreado')).fromNow()}
        />,
        <MaterialUI.Divider key={'divider_' + solicitud.get('id')} inset={true} />,
      );
    });
    for (const key in elementsPerIDSolicitud) {
      returnElements.push(
        <Col md="6" key={key} className="pt-20">
          <MaterialUI.Paper>
            <MaterialUI.List className="container">{elementsPerIDSolicitud[key]}</MaterialUI.List>
          </MaterialUI.Paper>
        </Col>,
      );
    }
  } catch (err) {
    console.log('err', err);

    return <h1 className="textCenter pt-20">Hubo un error</h1>;
  }
  return <Row className="pt-25">{returnElements.map(element => element)}</Row>;
};



// WEBPACK FOOTER //
// src/modules/gruposSolicitudes/components/lista.js